import { useCallback, useContext, useState } from "react";
import { API } from "../global/global";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";

export const usePDFPreview = () => {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  const previewPDF = useCallback(
    async (idActividad: number, sinFotos: boolean = false) => {
      if (!idActividad) {
        toast.error("ID de actividad no válido");
        return;
      }

      setLoading(true);
      
      try {
        const plataformaId = authContext.plataformas.length > 0 ? authContext.plataformas[0].id : null;
        const endpoint = sinFotos ? 'downloadPDFSinFotos' : 'downloadPDF';
        const url = `${API}/${endpoint}/${idActividad}${plataformaId ? `?plataforma_activa=${plataformaId}` : ''}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + authContext.token,
          },
          responseType: 'blob',
          timeout: 120000
        });

        const data = response.data;

        if (!data || data.size === 0) {
          toast.warning("El PDF generado está vacío");
          return;
        }

        // Crear URL del blob para previsualización
        const blobUrl = window.URL.createObjectURL(data);
        setPdfUrl(blobUrl);
        setShowModal(true);

      } catch (error: any) {
        console.error("Error al generar PDF:", error);
        
        if (error.code === 'ECONNABORTED') {
          toast.error("Timeout: El PDF está tardando mucho en generarse");
        } else if (error.response?.status === 404) {
          toast.error("Actividad no encontrada o no tienes permisos para verla");
        } else if (error.response?.status === 500) {
          toast.error("Error del servidor al generar el PDF");
        } else {
          toast.error("Error al generar el PDF. Intenta nuevamente.");
        }
      } finally {
        setLoading(false);
      }
    },
    [authContext.token, authContext.plataformas]
  );

  const closeModal = useCallback(() => {
    setShowModal(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  }, [pdfUrl]);

  return {
    previewPDF,
    loading,
    showModal,
    pdfUrl,
    closeModal
  };
};
